module.exports = __webpack_public_path__ + "img/hkstp-location.665780dc.jpg";